<template>
  <div>

    <f-table
            ref="fTable"
            v-if="tableStatus.mode!=='copy'"
             :loading="loading"
             :downloading="downloading"
             :tableStatus="tableStatus"
             :data="data"
             :statusList='statusList'
             :topicList="topicList"
             :kpmgOwnerList="kpmgOwnerList"
             @selectKPOwner="selectKPOwner"
             :clientOwnerList="clientOwnerList"
             @selectClientOwner="selectClientOwner"
             :pagination="pagination"
             :onCancel="onCancel"
             :onChange="onChange"
             :onPaginationChange="onPaginationChange"
             :onChangeStatusPopShow="onChangeStatusPopShow"
             :onUploadFileAfter="onUploadFileAfter"
             :sourceTypes="sourceTypes"
             :onChangeRow="onChangeRow"
             :onDownLoad="onDownLoad"
             :downloadAble="downloadAble"
             :curUserName="curUserName"
             :siteId="siteId"
             @on-dueday-change="onDuedayChange"
             @on-charge-user-change="onChargeUserChange"
            @on-confirm-day-change="onConfirmDayChange"
            :showColumns="showColumns"
            :serialNo.sync="serialNoHere"
            :topic.sync="topicHere"
            :topicDesList="topicDesList"
            :topicDes.sync="topicDesHere"
            :createDate.sync="createDateHere"
            :dueTime.sync="dueTimeHere"
            :sourceOfInfo.sync="sourceOfInfoHere"
            :filterStatusList="filterStatusList"
            :status.sync="statusHere"
            :dayOverDue.sync="dayOverDueHere"
            :daysUntilDue.sync="daysUntilDueHere"
            :uploadTime.sync="uploadTimeHere"
            :periodEndDate.sync="periodEndDateHere"
            :commentDate.sync="commentDateHere"
            :fileName.sync="fileNameHere"
            :clientResponsible.sync="clientResponsibleHere"
            :kpmgResponsible.sync="kpmgResponsibleHere"
            :updateGuide="updateGuide"
            :updateGuideStep="updateGuideStep"
            @nextClick="nextClick"
            :lastedUploadUserAccount.sync="lastedUploadUserAccountHere"
            :screenWidth="screenWidth"
            :clientConfirmDate.sync="clientConfirmDateHere"
            :messageType="messageType"
             ></f-table>

    <!-- 点击Copy From Interim 表格不一样 -->

    <m-table v-else
             :data="dataPBC"
             :tableStatus="tableStatus"
             :onCancel="onCancelInterim"
             :onCopy="onCopy"
             :loading="loading"></m-table>

  </div>

</template>
<script>
import FTable from './final-table';
import MTable from './interim-table';
export default {
    name: 'pbc-table',
    data() {
        return {
            chosenList: [],
            serialNoHere: '',
            topicHere: [],
            topicDesHere: [],
            createDateHere: [],
            dueTimeHere: [],
            sourceOfInfoHere: [],
            statusHere: [],
            dayOverDueHere: ['', ''],
            daysUntilDueHere: ['', ''],
            uploadTimeHere: [],
            periodEndDateHere: [],
            commentDateHere: [],
            fileNameHere: '',
            clientResponsibleHere: [],
            kpmgResponsibleHere: [],
            lastedUploadUserAccountHere: [],
            clientConfirmDateHere: ['', '']
        };
    },
    methods: {
        changeGuideTitleHeight() {
            this.$refs.fTable.changeGuideTitleHeight()
        },
        resetNotStatus(allEntityIds) {
            this.$refs.fTable.resetNotStatus(allEntityIds)
        },
        cleanFilter(allEntityIds) {
            this.$refs.fTable.cleanFilter(allEntityIds)
        },
        initStartIndex() {
            this.$refs.fTable.initStartIndex()
        },
        handleSelectionChange(v) {
            this.chosenList = v;
        },
        changeStatus() {
            this.onChangeStatusPopShow(this.chosenList);
        },
        downLoad() {
            this.onDownLoad(this.chosenList);
        },
        selectClientOwner() {
            this.$emit('selectClientOwner')
        },
        selectKPOwner() {
            this.$emit('selectKPOwner')
        },
        onDuedayChange () {
            this.$emit('on-dueday-change', ...arguments);
        },
        onChargeUserChange () {
            this.$emit('on-charge-user-change', ...arguments);
        },
        onConfirmDayChange () {
            this.$emit('on-confirm-day-change', ...arguments);
        },
        nextClick () {
            this.$emit('nextClick');
        },
    },
    computed: {
        tableHeight() {
            let reduce = this.tableStatus.editable ? 96 : 40;

            if (this.tableStatus.mode === 'copy') {
                reduce -= 30;
            }

            return `calc(100% - ${reduce}px)`;
        },
        emptyChosen() {
            return _.isEmpty(this.chosenList);
        }
    },
    watch: {
        clientResponsibleHere(v) {
            this.$emit('update:clientResponsible', v)
        },
        kpmgResponsibleHere(v) {
            this.$emit('update:kpmgResponsible', v)
        },
        fileNameHere(v) {
            this.$emit('update:fileName', v)
        },
        periodEndDateHere(v) {
            this.$emit('update:periodEndDate', v)
        },
        commentDateHere(v) {
            this.$emit('update:commentDate', v)
        },
        uploadTimeHere(v) {
            this.$emit('update:uploadTime', v)
        },
        dayOverDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:dayOverDue', v)
            }
        },
        daysUntilDueHere: {
            deep: true,
            handler(v) {
                this.$emit('update:daysUntilDue', v)
            }
        },
        serialNoHere(v) {
            this.$emit('update:serialNo', v)
        },
        topicHere(v) {
            this.$emit('update:topic', v)
        },
        topicDesHere(v) {
            this.$emit('update:topicDes', v)
        },
        createDateHere(v) {
            this.$emit('update:createDate', v)
        },
        dueTimeHere(v) {
            this.$emit('update:dueTime', v)
        },
        sourceOfInfoHere(v) {
            this.$emit('update:sourceOfInfo', v)
        },
        statusHere(v) {
            this.$emit('update:status', v)
        },
        lastedUploadUserAccount(v) {
            this.lastedUploadUserAccountHere = v
        },
        lastedUploadUserAccountHere(v) {
            this.$emit('update:lastedUploadUserAccount', v)
        },
        serialNo(v) {
            this.serialNoHere = v
        },
        topic(v) {
            this.topicHere = v
        },
        topicDes(v) {
            this.topicDesHere = v
        },
        createDate(v) {
            this.createDateHere = v
        },
        dueTime(v) {
            this.dueTimeHere = v
        },
        sourceOfInfo(v) {
            this.sourceOfInfoHere = v
        },
        status(v) {
            this.statusHere = v
        },
        dayOverDue(v) {
            this.dayOverDueHere = v
        },
        daysUntilDue(v) {
            this.daysUntilDueHere = v
        },
        clientResponsible(v) {
            this.clientResponsibleHere = v
        },
        kpmgResponsible(v) {
            this.kpmgResponsibleHere = v
        },
        uploadTime(v) {
            this.uploadTimeHere = v
        },
        periodEndDate(v) {
            this.periodEndDateHere = v
        },
        commentDate(v) {
            this.commentDateHere = v
        },
        fileName(v) {
            this.fileNameHere = v
        },
        clientConfirmDate(v) {
            this.clientConfirmDateHere = v
        },
        clientConfirmDateHere(v) {
            this.$emit('update:clientConfirmDate', v)
        }
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        sourceTypes: {
            type: Array,
            default: () => []
        },
        dataPBC: {
            type: Array,
            default: () => []
        },
        tableStatus: {
            type: Object,
            required: true
        },
        onCancel: {
            type: Function,
            default: () => {}
        },
        onCancelInterim: {
            type: Function,
            default: () => {}
        },
        onCopy: {
            type: Function,
            default: () => {}
        },
        statusList: {
            type: Array,
            default: () => []
        },
        topicList: {
            type: Array,
            required: true,
            default: () => []
        },
        kpmgOwnerList: {
            type: Array,
            required: true,
            default: () => []
        },
        clientOwnerList: {
            type: Array,
            required: true,
            default: () => []
        },
        onChange: {
            type: Function,
            required: true
        },
        onChangeRow: {
            type: Function,
            required: true
        },
        onChangeStatusPopShow: {
            type: Function
        },
        onDownLoad: {
            type: Function
        },
        onUploadFileAfter:{
            type: Function
        },
        loading: Boolean,
        downloading: Boolean,
        pagination: Object,
        onPaginationChange: Function,
        downloadAble: Boolean,
        curUserName: String,
        siteId: String,
        showColumns: Array,
        serialNo: String,
        topic: Array,
        topicDesList: Array,
        topicDes: Array,
        createDate: Array,
        dueTime: Array,
        sourceOfInfo: Array,
        filterStatusList: Array,
        status: Array,
        uploadTime: Array,
        periodEndDate: Array,
        commentDate: Array,
        fileName: String,
        clientResponsible: Array,
        kpmgResponsible: Array,
        updateGuide: Boolean,
        updateGuideStep: Number,
        screenWidth: Number,
        lastedUploadUserAccount: Array,
        messageType: String,
        dayOverDue: {
            type: Array,
            default: () => ['', '']
        },
        daysUntilDue: {
            type: Array,
            default: () => ['', '']
        },
        clientConfirmDate: {
            type: Array,
            default: () => ['', '']
        }
    },
    components: {
        MTable,
        FTable
    }
};
</script>
<style scoped>
.wl-table {
    margin-bottom: 6px;
}
.wl-btn-container {
    height: 48px;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
